export const environment = {
    production: false,
    api: {
        https: true,
        msSystem: {
            url: 'https://api.system.dev-synthrone.io/v1',
            systemToken: true
        },
        msLanguageCountry: {
            url: 'https://api.language-country.dev-synthrone.io/v1',
            systemToken: true
        },
        manager: {
            host: 'manager.dev-synthrone.io'
        },
        crafter: {
            host: 'crafter.dev-synthrone.io'
        },
        publisher: {
            host: 'publisher.dev-synthrone.io'
        },
        adminer: {
            host: 'adminer.dev-synthrone.io'
        },
        tracker: {
            host: 'tracker.dev-synthrone.io'
        },
        explorer: {
            host: 'explorer.dev-synthrone.io'
        },
        clc: {
            host: 'clc.dev-synthrone.io'
        },
        notifications: {
            host: 'microservices.dev-synthrone.io'
        },
        resources: {
            cdn: 'cdn01.dev-synthrone.io'
        },
        msClient: {
            url: 'https://api.client.dev-synthrone.io/v1',
            systemToken: true
        },
        msUser: {
            url: 'https://api.user.dev-synthrone.io/v1',
            systemToken: true
        },
        msAuthorization: {
            url: 'https://api.authorization.dev-synthrone.io/v1',
            systemToken: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts